export enum ImporterState {
  idle,
  fileUploading,
  fileUploaded,
  fileImporting,
  fileImported,
  fileAggregating,
  fileAggregated
}

export enum ImportCompleteState {
  running = 'active',
  complete = 'complete',
  completeConflicts = 'complete-conflicts',
  fail = 'fail'
  // passWithErrors = 'softComplete'
}
